import RankingOutputEdit from "./RankingOutputEdit";

export default {
    Edit: RankingOutputEdit
};
